import { TIMEZONES } from '../../../../../helpers/constants'
import { getAssetLink } from '../../../../../helpers/get-asset-link'

export const getTrainingTypes = (services) => {
  const trainingTypes = services.filter((s) => s.serviceId && s.serviceId.personal === true)
  return trainingTypes.map((t) => {
    return {
      id: t.serviceId.id,
      avatar: t.serviceId.icon,
      text: t.serviceId.name,
      color: t.serviceId.color,
      personal: t.serviceId.personal,
      bookingType: t.serviceId.bookingType ? t.serviceId.bookingType.name : '',
      value: t.serviceId.id,
      label: t.serviceId.name,
    }
  })
}

export const getClientOptions = (clients) => {
  return clients.map((client) => {
    return {
      id: client.id,
      avatar: getAssetLink({ path: 'chitown-avatar/avatar', file: client.user.avatar }) || 'city',
      text: client.user.firstName + ' ' + client.user.lastName,
      timezone: client.buildingId ? client.buildingId.timezone : TIMEZONES.CT,
      value: client.id,
      label: client.user.firstName + ' ' + client.user.lastName,
    }
  })
}
